import { render, staticRenderFns } from "./KT-SalesGoals.vue?vue&type=template&id=34dab630&lang=pug&"
import script from "./KT-SalesGoals.vue?vue&type=script&lang=js&"
export * from "./KT-SalesGoals.vue?vue&type=script&lang=js&"
import style0 from "./KT-SalesGoals.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports